import { useMemo } from 'react';
import './Pagination.scss';

interface PaginationProps {
  currentPage: number;
  pageCount: number;
  onChange: (page: number) => void;
}

export function Pagination(props: PaginationProps) {
  const offset = 4;
  const { currentPage, pageCount } = props;

  const pages = useMemo(() => {
    const result: { index: number; visible: boolean }[] = [];
    if (pageCount < 2 || currentPage > pageCount - 1) {
      return result;
    }
    const startRemainder = Math.min(currentPage - offset, 0);
    const endRemainder = Math.min(pageCount - offset - 1 - currentPage, 0);
    const start = Math.max(currentPage - offset + endRemainder, 0);
    const end = Math.min(currentPage + offset + 1 - startRemainder, pageCount);
    for (let i = start; i < end; i++) {
      result.push({ index: i, visible: true });
    }
    for (let i = 1; i <= offset; i++) {
      if (start - i > -1) {
        result.unshift({ index: start - i, visible: false });
      }
      if (end - 1 + i <= pageCount) {
        result.push({ index: end - 1 + i, visible: false });
      }
    }

    return result;
  }, [currentPage, pageCount]);

  const getClassName = (index: number, visible: boolean) => {
    if (currentPage === index) {
      return 'current';
    } else if (!visible) {
      return 'hidden';
    }
  };

  return (
    <div className='grid-pagination'>
      <button onClick={() => props.onChange(0)} className={currentPage <= offset ? 'hidden' : ''}>
        <i className="icon-left" />
        <i className="icon-left" />
      </button>
      <button
        onClick={() => props.onChange(currentPage - 1)}
        className={currentPage < 1 ? 'hidden' : ''}
      >
        <i className="icon-left" />
      </button>
      {pages.map((p) => (
        <button
          key={p.index}
          className={getClassName(p.index, p.visible)}
          onClick={() => props.onChange(p.index)}
        >
          {p.index + 1}
        </button>
      ))}
      <button
        onClick={() => props.onChange(currentPage + 1)}
        className={currentPage >= pageCount - 1 ? 'hidden' : ''}
      >
        <i className="icon-right" />
      </button>
      <button
        onClick={() => props.onChange(pageCount - 1)}
        className={currentPage >= pageCount - offset - 1 ? 'hidden' : ''}
      >
        <i className="icon-right" />
        <i className="icon-right" />
      </button>
    </div>
  );
}
